import { Global } from '@emotion/react';
import { colors } from '@rtkwlf/fenrir-react';

export const GlobalStyles = () => (
  <Global
    styles={{
      // TODO: S2CX-2820: remove scrollbar styles
      '::-webkit-scrollbar': {
        height: '8px',
        width: '8px',
      },
      '::-webkit-scrollbar-thumb': {
        backgroundColor: '#727272',
        borderRadius: '8px',
      },
      '::-webkit-scrollbar-track': {
        background: 'transparent',
      },

      // * transition between fenrir legacy and fenrir *
      // - needs to be outside of global layer to properly override fenrir
      body: {
        // update to fenrir defaults while transitioning to up-ia
        backgroundColor: 'var(--aw-palette-background-base)',
        color: 'var(--aw-palette-text-primary)',
        // - include line-height: normal to override Mui global styles
        lineHeight: 'normal',
      },
      // make global styles less specific to allow easy override
      '@layer global': {
        a: {
          color: `rgb(${colors.text.brand.default})`,
        },
        ul: {
          listStyleType: 'none',
          margin: 0,
          padding: 0,
        },
      },
    }}
  />
);
